var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("h3", [_vm._v("Article Overrides")]),
    _vm._v(" "),
    _c(
      "ul",
      { staticClass: "checkbox-container" },
      _vm._l(_vm.overrides, function (override, overrideIndex) {
        return _c("li", [
          _c("input", {
            attrs: { type: "checkbox", id: override.key, name: "", value: "" },
            domProps: {
              checked: _vm.enabledOverrides.indexOf(override.id) != -1,
            },
            on: {
              click: function ($event) {
                return _vm.toggleOverride(override)
              },
            },
          }),
          _vm._v(" "),
          _c(
            "label",
            {
              on: {
                click: function ($event) {
                  return _vm.toggleOverride(override)
                },
              },
            },
            [_vm._v(_vm._s(override.name))]
          ),
        ])
      }),
      0
    ),
    _vm._v(" "),
    !_vm.saving
      ? _c(
          "button",
          {
            on: {
              click: function ($event) {
                return _vm.saveOverrides()
              },
            },
          },
          [_vm._v("Save")]
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.saving
      ? _c("span", {
          staticClass: "icon fas fa-spinner fa-spin",
          attrs: { "aria-hidden": "true" },
        })
      : _vm._e(),
    _vm._v(" "),
    _c(
      "p",
      {
        style: {
          color: _vm.saveMessageColor,
        },
      },
      [_vm._v("\n\t\t" + _vm._s(_vm.saveMessage) + "\n\t")]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }